export const InteractionSettings = Object.freeze({
	searchDebounceTime: 300, // in milliseconds
});
